<template>
  <BaseModal
    :show="show"
    @close="close"
  >
    <div
      class="modal-header"
      v-text="'Document history'"
    />
    <div class="modal-body">
      <div>
        <table class="w-full">
          <tr
            is="DocumentRow"
            v-for="item in history.data"
            :key="item.uuid"
            :document="item"
          />
        </table>
      </div>
    </div>
    <div class="modal-footer text-center mt-4">
      <button
        type="button"
        class="btn btn--border"
        @click="close"
        v-text="'Close'"
      />
    </div>
  </BaseModal>
</template>

<script type="text/babel">
import DocumentRow from './DocumentHistoryRow'

export default {
  name: 'DocumentHistoryModal',
  components: {
    DocumentRow,
  },
  props: {
    parentFolderUuid: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      history: {
        data: [],
      },
    }
  },
  computed: {
    document() {
      return this.$store.state.document.documentHistoryModal.document
    },
    show() {
      return this.$store.state.document.documentHistoryModal.open
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.loading = true

        this.$api.active().get(`documents/${this.document.uuid}/history`)
          .then((response) => {
            this.history = response.data
          })
      }
    },
  },
  methods: {
    close() {
      this.$store.commit('documentCloseDocumentHistoryModal')
    },
  },
}
</script>
